<div class="card">
  <div class="row">
    <div class="col-1"></div>
    <div class="col-10 header">
      <span class="header">Disposition Build</span>
    </div>
    <div class="col-1">
      <button
        type="button"
        class="btn-close float-end"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="openHome()"
      ></button>
    </div>
    <!-- Wrap divider in a constrained div -->
    <div style="width: 98%; margin-left: 1%; margin-right: 1%">
      <hr class="divider" />
    </div>
    <!-- Main Card Body -->
    <div class="row" style="width: 98%; margin-left: 1%; margin-right: 1%">
      <div class="col-5">
        <mat-stepper
          orientation="vertical"
          [linear]="true"
          #stepper
          style="min-height: 765px"
          >
          <!-- 1 Select Reserved Firearm(s)-->
          <mat-step
            [completed]="
              sharedService.dispo_build_reserved_firearms?.length > 0
            "
            [editable]="true"
            >
            <ng-template matStepLabel>
              <span
                [ngClass]="{
                  'bg-active': stepper.selectedIndex === 0,
                  'bg-inactive':
                    stepper.selectedIndex !== 0 &&
                    !sharedService.dispo_build_reserved_firearms?.length
                }"
                >
                Select Reserved Firearm
              </span>
            </ng-template>
            <div class="row align-items-center">
              <div class="col">
                <button
                  class="btn btn-primary btn-sm"
                  (click)="sharedService.openDispoBuildModal('select_firearm')"
                  >
                  Select Reserved Firearm(s)
                </button>
              </div>
            </div>
          </mat-step>
          <!-- 2 Select Buyer 4473 -->
          <mat-step
            [completed]="
              sharedService.dispo_build_selected_transferee_4473.name_first
                ?.length > 0 ||
              sharedService.dispo_build_manual_entered_id.id_number?.length > 0
            "
            [editable]="true"
            >
            <ng-template matStepLabel>
              <span
                [ngClass]="{
                  'bg-active': stepper.selectedIndex === 1,
                  'bg-inactive':
                    stepper.selectedIndex !== 1 &&
                    !sharedService.dispo_build_reserved_firearms?.length
                }"
                >
                Select Buyer's 4473
              </span>
            </ng-template>
            <div class="row align-items-center">
              <div class="col">
                <button
                  class="btn btn-primary btn-sm"
                  (click)="
                    sharedService.openDispoBuildModal('select_buyer_4473')
                  "
                  >
                  Select Buyer 4473
                </button>
              </div>
            </div>
          </mat-step>
          <!-- 3 Select ID -->
          <mat-step
            [completed]="
              sharedService.dispo_build_selected_drivers_license.licenseNumber?.length > 0 || 
              sharedService.dispo_build_manual_entered_id.id_number?.length > 0
            "
            [editable]="true"
            >
            <ng-template matStepLabel>
              <span
                [ngClass]="{
                  'bg-active': stepper.selectedIndex === 2,
                  'bg-inactive':
                    stepper.selectedIndex !== 2 &&
                    !sharedService.dispo_build_reserved_firearms?.length
                }"
                >
                Select Buyers Driver's License
              </span>
            </ng-template>
            <div class="row align-items-center">
              <div class="col">
                <div class="d-flex flex-row gap-2">
                  <button
                    class="btn btn-primary btn-sm"
                    (click)="
                      sharedService.openDispoBuildModal(
                        'select_buyer_driver_license'
                      )
                    "
                    >
                    Select Drivers License
                  </button>
                  @if (
                    !sharedService.dispo_build_manual_entered_id.id_number
                    ?.length
                    ) {
                    <button
                      class="btn btn-primary btn-sm"
                    (click)="
                      sharedService.openEnterIdModal(minimum_are_requirement)
                    "
                      >
                      Enter ID
                    </button>
                  }
                  @if (
                    sharedService.dispo_build_manual_entered_id.id_number
                    ?.length
                    ) {
                    <button
                      class="btn btn-primary btn-sm"
                    (click)="
                      sharedService.openEnterIdModal(minimum_are_requirement)
                    "
                      >
                      Edit ID
                    </button>
                  }
                </div>
              </div>
            </div>
          </mat-step>
          <!-- 4 Create Seller 4473 -->
          <mat-step
            [completed]="seller_4473_saved"
            [editable]="true"
            >
            <ng-template matStepLabel>
              <span
                [ngClass]="{
                  'bg-active': stepper.selectedIndex === 3,
                  'bg-inactive':
                    stepper.selectedIndex !== 3 &&
                    !sharedService.dispo_build_reserved_firearms?.length
                }"
                >
                Create Seller 4473
              </span>
            </ng-template>
            <div class="row align-items-center">
              <div class="col">
                <button
                  class="btn btn-primary btn-sm"
                  (click)="
                    sharedService.openDispoBuildModal('select_seller_4473')
                  "
                  >
                  Create Seller 4473
                </button>
              </div>
            </div>
          </mat-step>
          <!-- 5 Review and Sign 4473 -->
          <mat-step
            [completed]="
              sharedService.dispo_build_seller_4473.transferor_signature
            "
            [editable]="true"
            >
            <ng-template matStepLabel>
              <span
                [ngClass]="{
                  'bg-active': stepper.selectedIndex === 4,
                  'bg-inactive':
                    stepper.selectedIndex !== 4 &&
                    !sharedService.dispo_build_reserved_firearms?.length
                }"
                >
                Review and Sign 4473 PDF
              </span>
            </ng-template>
            <div class="row align-items-center">
              <div class="col">
                <button
                  class="btn btn-primary btn-sm"
                  (click)="reviewAndSign4473()"
                  >
                  Review & Sign 4473 PDF
                </button>
              </div>
            </div>
          </mat-step>
          <!-- 6 Record 4473 -->
          <mat-step>
            <ng-template matStepLabel>
              <span
                [ngClass]="{
                  'bg-active': stepper.selectedIndex === 5,
                  'bg-inactive':
                    stepper.selectedIndex !== 5 &&
                    !sharedService.dispo_build_reserved_firearms?.length
                }"
                >
                Record 4473
              </span>
            </ng-template>
            <p>You are now done.</p>
            <div>
              <button matButton (click)="stepper.reset()">Reset</button>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
      <div class="col-7 background-img d-flex flex-column" style="height: 100%">
        <!-- Selected Firearms Right Side -->
        <div class="row" style="flex: 5 1 20%">
          @if (sharedService.dispo_build_reserved_firearms[0]?._id) {
            <div>
              <span class="right-side-header" style="color: white"
                >Reserved Firearm(s)</span
                >
                @for (firearm of sharedService.dispo_build_reserved_firearms; track
                  firearm.bound_book_id) {
                  <div>
                    <input
                      class="form-control"
                      type="firearm"
                      id="firearm_{{ firearm.firearm_id }}"
                [ngModel]="
                  firearm?.firearm
                    ? firearm.firearm +
                      ' (Serial: ' +
                      firearm.serial_number +
                      ')'
                    : ''
                "
                      style="width: 500px; margin-bottom: 10px"
                      disabled
                      />
                    </div>
                  }
                </div>
              }
            </div>
            <!-- Selected Buyer 4473  Right Side -->
            <div class="row" style="flex: 5 1 20%">
              @if (
                sharedService.dispo_build_selected_transferee_4473?.name_first
                ) {
                <div
                  >
                  <span class="right-side-header" style="color: white"
                    >Buyer 4473:</span
                    >
                    <input
                      class="form-control"
                      type="buyer_4473"
                      id="buyer_4473"
                      style="width: 300px; height: 40px"
              [ngModel]="
                sharedService.dispo_build_selected_transferee_4473.name_first
                  ? sharedService.dispo_build_selected_transferee_4473
                      .name_first +
                    ' ' +
                    sharedService.dispo_build_selected_transferee_4473
                      .name_last +
                    '   DOB: ' +
                    sharedService.dispo_build_selected_transferee_4473
                      .birth_month +
                    '-' +
                    sharedService.dispo_build_selected_transferee_4473
                      .birth_day +
                    '-' +
                    sharedService.dispo_build_selected_transferee_4473
                      .birth_year
                  : ''
              "
                      disabled
                      />
                    </div>
                  }
                </div>
                <!-- Selected Buyer ID  Right Side -->
                <div class="row" style="flex: 5 1 20%">
                  @if (
                    sharedService.dispo_build_manual_entered_id?.name_first ||
                    sharedService.dispo_build_selected_drivers_license?.driversId
                    ) {
                    <div
                      >
                      <span class="right-side-header" style="color: white"
                        >Buyer's ID:</span
                        >
                        <input
                          class="form-control"
                          type="buyer_drivers_license"
                          id="buyer_drivers_license"
              [ngModel]="
                sharedService.dispo_build_selected_drivers_license.licenseNumber
                  ? sharedService.dispo_build_selected_drivers_license
                      .nameFirst +
                    ' ' +
                    sharedService.dispo_build_selected_drivers_license
                      .nameLast +
                    '   ID: ' +
                    sharedService.dispo_build_selected_drivers_license
                      .licenseNumber
                  : sharedService.dispo_build_manual_entered_id.id_number
                  ? sharedService.dispo_build_manual_entered_id.name_first +
                    ' ' +
                    sharedService.dispo_build_manual_entered_id.name_last +
                    '   ID: ' +
                    sharedService.dispo_build_manual_entered_id.id_number
                  : ''
              "
                          style="width: 375px"
                          disabled
                          />
                        </div>
                      }
                    </div>
                    <!-- Seller 4473 Created  Right Side -->
                    <div class="row" style="flex: 5 1 20%">
                      @if (sharedService.dispo_build_seller_4473?.transferor_signature) {
                        <div>
                          <span class="right-side-header" style="color: white"
                            >Seller 4473:</span
                            >
                            <input
                              class="form-control"
                              type="firearm"
                              id="firearm"
                              style="width: 300px"
                              disabled
                              [ngModel]="translateNicsResponse()"
                              />
                            </div>
                          }
                        </div>
                        <!-- Reviewed and Signed 4473 Right Side -->
                        <div class="row" style="flex: 5 1 20%">
                          @if (
                            sharedService.dispo_build_seller_4473?.id_issuing_authority
                            ) {
                            <div
                              >
                              <span class="right-side-header" style="color: white"
                                >Review and Sign 4473:</span
                                >
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
